export const menuCancelDisabled = state =>
  state.requests.request.isCancelled || state.requests.request.isCompleted || state.requests.request.isTurndown;

export const showDetailsQuestion = state => state.user.model.isDispatcher;

export const cancelDisabled = state =>
  !(state.cancelRequest.cancelReasonTypeId && (state.cancelRequest.details.length > 0 || !showDetailsQuestion(state)));

export const cancelRestricted = state =>
  Boolean(
    state.user.model.isRequester &&
    state.agency.requesterAgencyGroup?.requestersCannotCancelActiveOfferedTrips &&
    (state.offers?.offers || []).some(offer => offer?.offerStatus?.name === 'accepted'),
  );
